import React, { useEffect, useState } from "react";
import "../../assets/css/utmlBuilder.css"
import "bootstrap/dist/css/bootstrap.css";
import { getChannels, getChannelConfig } from '../../api/CustomerJourney'
import SupportLink from "../Common/SupportLink";

function UtmlBuilder(props) {

    const [url, setUrl] = useState('');
    const [campName, setCampName] = useState('');
    const [source, setSource] = useState('');
    const [medium, setMedium] = useState('');
    const [utml, setutml] = useState('');
    const [term, setterm] = useState('');
    const [content, setcontent] = useState('');

    const [channels, setChannels] = useState([]);

    const [selectedChannel, setSelectedChannel] = useState('');

    useEffect(() => {
        getChannels().then(data => {
            setChannels(data);
        })

    }, [])
    const handleSelect = (e) => {
        setSelectedChannel(e.target.value)
        if (e.target.value == '0')
            return;
        getChannelConfig(e.target.value).then(d => {
            setCampName(d.utm_campaign || '')
            setMedium(d.utm_medium || '')
            setSource(d.utm_source || '')
            setcontent(d.utm_content || '')
            let term = d.utm_term || ''
            setterm(term || '')

            buildUrl(d.utm_campaign, d.utm_source, d.utm_medium, url, term, d.utm_content || '')
        })

    }

    const buildUrl = (c, s, m, u, term, content) => {
        setutml(`${u}?utm_campaign=${c}&utm_source=${s}&utm_medium=${m}&utm_term=${term}&utm_content=${content}`)

    }
    const urlChange = (v) => {
        setUrl(v);
        buildUrl(campName, source, medium, v)

    }
    const campNameChange = (v) => {
        setCampName(v);
        buildUrl(v, source, medium, url, term, content)
    }
    const sourceChange = (v) => {
        setSource(v);
        buildUrl(campName, v, medium, url, term, content)
    }
    const mediumChange = (v) => {
        setMedium(v);
        buildUrl(campName, source, v, url, term, content)
    }

    const termChange = (v) => {
        setterm(v);
        buildUrl(campName, source, medium, url, v, content)
    }
    const contentChange = (v) => {
        setcontent(v);
        buildUrl(campName, source, medium, url, term, v)
    }

    const copyUtml = () => {
        navigator.clipboard.writeText(utml);
    }
    return (<>
        <SupportLink link='https://kapitalwise.com/user-guide/tags#utm' />
        <div className="utm page_heading">
            <h2>UTM Builder</h2>
        </div>
        <div className="utm mainCont">

            <div style={{position: 'relative'}}>
                <div id="ch-span" >Channel:</div>
                <select style={{ paddingLeft: '70px' }} value={selectedChannel} onChange={handleSelect} id='mainSelect'>

                    <option value={0} >Custom</option>
                    {channels.map(ch => {
                        return <option value={ch.id}>{ch.label}</option>
                    })}

                </select>
            </div>

            <h6 className="label-t">Fill this form to create a trackable link to copy.</h6>
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: '50px' }}>
                <textarea value={utml} id='utmlTextArea' readOnly placeholder="As you fill the form your link will preview here"></textarea>
                <button onClick={copyUtml} style={{ height: '44px', margin: '15px' }} type="button" class="btn btn-default">Copy Link</button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>


                <div className="elemBox" >
                    <h2 className="title-t">Website URL </h2>
                    <input value={url} onChange={(e) => urlChange(e.target.value)} className="att-textbox" type="text"></input>
                    <h6 className="label-t" >Your website URL (e.g. https://www.example.com) </h6>
                </div>

                <div className="elemBox" >
                    <h2 className="title-t">Campaign Name  <span className="ti-span">(utm_campaign)</span></h2>
                    <input value={campName} onChange={(e) => campNameChange(e.target.value)} className="att-textbox" type="text"></input>
                    <h6 className="label-t" >Product, promo code, or slogan (e.g. summer_sale) </h6>
                </div>

                <div className="elemBox" >
                    <h2 className="title-t">Source <span className="ti-span">(utm_source)</span></h2>
                    <input value={source} onChange={(e) => sourceChange(e.target.value)} className="att-textbox" type="text"></input>
                    <h6 className="label-t" >The referrer: (e.g. facebook, newsletter)</h6>
                </div>

                <div className="elemBox" >
                    <h2 className="title-t">Medium <span className="ti-span">(utm_medium)</span></h2>
                    <input value={medium} onChange={(e) => mediumChange(e.target.value)} className="att-textbox" type="text"></input>
                    <h6 className="label-t" >Marketing medium: (e.g. display ads or email) </h6>
                </div>

                <div className="elemBox" >
                    <h2 className="title-t">Term <span className="ti-span">(utm_term)</span></h2>
                    <input value={term} onChange={(e) => termChange(e.target.value)} className="att-textbox" type="text"></input>
                    <h6 className="label-t" >Identify the paid keywords </h6>
                </div>

                <div className="elemBox" >
                    <h2 className="title-t">Content <span className="ti-span">(utm_content)</span></h2>
                    <input value={content} onChange={(e) => contentChange(e.target.value)} className="att-textbox" type="text"></input>
                    <h6 className="label-t" >Differentiate identical links or A/B test (e.g. logoLink or emailVariantA) </h6>
                </div>

            </div>

        </div>
    </>
    )


}

export default UtmlBuilder;